import { useState, useEffect } from "react";
// import { rootUrl } from "../App";
import TC from "../Pages/TC/TC";
import useFetchData from "./useFetchData"; // ✅ import your cached hook

export const useStaticRoutes = () => {
    const [staticRoutes, setStaticRoutes] = useState([]);

    const makeSlug = (title) =>
        title
            ?.toLowerCase()
            .replace(/&/g, "and")       // replace & with 'and'
            .replace(/[^a-z0-9]+/g, "-") // replace non-alphanumeric with '-'
            .replace(/^-+|-+$/g, "");

    // ---------------------------
    // use your cached hook
    // ---------------------------
    const { data, loading, error, refetch } = useFetchData("/statics/page-content/", {
        method: "GET",
        cacheFor: 24 * 60 * 60 * 1000, // ✅ 24 hours persistent cache
    });

    useEffect(() => {
        if (data?.data) {
            const routes = data.data.map((page, index) => ({
                id: 1000 + index, // avoid clashing with existing IDs
                name: page?.title,
                path: `/${makeSlug(page?.title)}`,
                pageTitle: page?.title,
                component: <TC from={page} />,
                public: true,
            }));
            setStaticRoutes(routes);
        }
    }, [data]);

    return { staticRoutes, loading, error, refetch };
};
